import React from 'react';
import { ButtonWithText } from '../../atoms/Buttons/ButtonWithText';
import { ExtenalLinkVariant } from '../../atoms/Links/ExternalLink';
import useStyle from './cardFooter.style';
import { Icon } from '../../atoms/Icons';
import { ButtonVariant } from '../../../types/button/buttonVariant.def';
import { CarouselRessources } from '../Carousel/CarouselRessources';

export interface CardFooterLinks {
  href: string;
  text: string;
  variant: ExtenalLinkVariant;
  icon: Icon;
  color: string;
}
export interface CardFooterBtns {
  onClick: () => void;
  text: string;
  variant: ButtonVariant;
  icon: Icon;
  iconColor?: string;
}

export interface CardFooterProps {
  links?: CardFooterLinks[];
  btns?: CardFooterBtns[];
  title?: string;
  onClick?: () => void;
}

const CardFooter = ({ btns, links, title, onClick }: CardFooterProps) => {
  const classes = useStyle();
  return (
    <div className={classes.titleWithRessources}>
      {title && <h4>{title}</h4>}
      <div className={classes.ressources}>
        {links && links.length > 0 && (
          <CarouselRessources links={links} onClick={onClick} />
        )}
        {btns &&
          btns?.map((btn, i) => (
            <ButtonWithText
              key={i}
              icon={btn.icon}
              content={btn.text}
              onClick={btn.onClick}
              variant={btn.variant}
              iconColor={btn.iconColor && btn.iconColor}
              iconSize="small"
            />
          ))}
      </div>
    </div>
  );
};

export default CardFooter;
